import { createSlice } from "@reduxjs/toolkit";

export const otherDocumentSlice = createSlice({
    name: "otherDocument",
    initialState: {
        pdfPath:"",
        pdfPathRR:""
    },
    reducers:{
        setOtherDocumentPdfPreview:(state, action) => {
            state.pdfPath = action.payload;
        },
        setOtherDocumentRRPdfPreview:(state, action) => {
            state.pdfPathRR = action.payload;
        }
    }
});

export const {
    setOtherDocumentPdfPreview,
    setOtherDocumentRRPdfPreview
} = otherDocumentSlice.actions;
export default otherDocumentSlice.reducer;
